import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import Diversity3Icon from "@mui/icons-material/Diversity3";
import {
  AnaltyticsIcon,
  CallRecords,
  DashboardIcon,
  DID,
  DisplayGroups,
  HashIcon,
  IncomingCallIcon,
  LiveBoards,
  MyXToneIcon,
  NCSPortalIcon,
  PhoneAnsweredIcon,
  PhoneAnsweredSmallIcon,
  PhoneIncomingCallIcon,
  PhoneRingingSmallIcon,
  Provision,
  Reports,
  SmsIcon,
  SoftphoneIcon,
  TenantAdminIcon,
  TimeZoneRestriction,
  ToolsIcon,
} from "../utils/icons/defaultIcons";
import ScrubTool from "../containers/tools/scrubTool";
// import PlanIcon from '../utils/icons/PlanIcon';
// import QualityIcon from '../utils/icons/QualityIcon';
// import PortfolioIcon from '../utils/icons/PortfolioIcon';
// import ReportIcon from '../utils/icons/ReportIcon';
// import FilesIcon from '../utils/icons/FilesIcon';
// import ResourceUtilizationIcon from '../utils/icons/ResourceUtilizationIcon';

export const LeftMenuItems = {
  control: [
    {
      item: "dashboard",
      path: "dashboard",
      displayName: "Dashboard",
      hidden: true,
      icon: <DashboardIcon />,
      permission: "",
    },
    {
      item: "extensions",
      path: "extensions",
      displayName: "Admin",
      icon: <TenantAdminIcon />,
      permission: "",
      childrens: [
        {
          item: "adminManagement",
          path: "adminManagement",
          displayName: "User Management",
          permission: "extensions_tenant_admin.get",
        },
      ],
    },
    // {
    //   item: "my_xtone",
    //   path: "myxtone",
    //   displayName: "My XTone",
    //   icon: <MyXToneIcon />,
    //   permission: "live_boards.live_boards.queue_monitor.get",
    // },
    {
      item: "call_recordings",
      path: "recordings",
      displayName: "Recordings",
      icon: <CallRecords />,
      permission: "",
      childrens: [
        {
          item: "call_recordings",
          path: "callrecordings",
          displayName: "Call Recordings",
          permission: "call_recordings.call_archives.get",
        },
      ],
    },
    {
      item: "timeZoneRestriction",
      path: "timeZoneRestriction",
      displayName: "Time Zone Restriction",
      icon: <TimeZoneRestriction />,
      permission: "",
    },

    {
      item: "live_calls",
      path: "livecalls",
      displayName: "Live Calls",
      icon: <LiveBoards />,
      permission: "",
      childrens: [
        // {
        //   item: "queue_monitor",
        //   path: "queuemonitor",
        //   displayName: "Queue Monitor",
        //   permission: "live_boards.queue_monitor.get",
        // },

        {
          item: "user_panel",
          path: "userpanelsettings",
          displayName: "User Panel",
          permission: "live_calls.user_panel.get",
        },
        {
          item: "wallboardsettings",
          path: "wallboardsettings",
          displayName: "Wallboard",
          permission: "live_calls.wallboard.get",
        },
        {
          item: "supervisor_view",
          path: "supervisorview",
          displayName: "Supervisor View",
          permission: "live_calls.supervisor_view.get",
        },

        // {
        //   item: "call_recordings",
        //   path: "manageExtension",
        //   displayName: "Manage Extension",
        //   permission: "call_recordings.manage_extension.get",
        // },
      ],
    },

    {
      item: "sms",
      path: "sms",
      displayName: "SMS",
      icon: <SmsIcon />,
      permission: "",
      childrens: [
        {
          item: "smsusers",
          path: "smsusers",
          displayName: "SMS Users",
          permission: "sms.sms_users.get",
        },
        // {
        //   item: "smsusers",
        //   path: "myxtone",
        //   displayName: "My XTone",
        //   permission: "sms.sms_users.get",
        // },
        // {
        //   item: "provisioning",
        //   path: "smsGroups",
        //   displayName: "SMS Groups",
        //   permission: "provision_tenants.get",
        // },
      ],
    },

    {
      item: "provision",
      path: "provision",
      displayName: "Provision",
      icon: <Provision />,
      permission: "",
      childrens: [
        {
          item: "provisioning",
          path: "tenants",
          displayName: "Tenants",
          permission: "provision_tenants.get",
        },
      ],
    },

    {
      item: "dids",
      path: "dids",
      displayName: "DIDs",
      icon: <DID />,
      permission: "dids.get",
    },

    {
      item: "dcid",
      path: "dcid",
      displayName: "DCID",
      icon: <HashIcon />,
      permission: "dcid.get",
    },

    {
      item: "my_xtone",
      path: "myxtone",
      displayName: "My XTone",
      icon: <MyXToneIcon />,
      permission: "my_xtone.get",
    },

    {
      item: "reports",
      path: "reports",
      displayName: "Reports",
      icon: <Reports />,
      permission: "",
      childrens: [
        {
          item: "callReports",
          path: "callReports",
          displayName: "Call Reports",
          permission: "reports.call_report.get",
        },
        {
          item: "callStatistics",
          path: "callStatistics",
          displayName: "Call Statistics",
          permission: "reports.call_statistics.get",
        },
        {
          item: "aboutReporting",
          path: "aboutReporting",
          displayName: "About Reporting",
          permission: "provision_tenants.get",
          // reports.about_reporting.get
        },
      ],
    },

    {
      item: "tools",
      path: "tools",
      displayName: "Tools",
      icon: <ToolsIcon />,
      permission: "",
      childrens: [
        {
          item: "scrubtool",
          path: "scrubtool",
          displayName: "Scrub Tool",
          permission: "tools.scrub_tool.get",
        },
        {
          item: "calls_in_progress",
          path: "activecalls",
          displayName: "Active Calls",
          permission: "tools.calls_in_progress.get",
        },
        {
          item: "displaygroups",
          path: "displaygroups",
          displayName: "Display Groups",
          permission: "tools.display_groups.get",
        },
        {
          item: "webhooks",
          path: "webhooks",
          displayName: "Webhooks",
          permission: "tools.webhook.get",
        },
      ],
    },
    {
      item: "softphone",
      path: "softphone",
      displayName: "Softphone",
      icon: <SoftphoneIcon />,
      permission: "softphone_supertelco.get",
    },
    {
      item: "softphone",
      path: "softphone",
      displayName: "Softphone",
      icon: <SoftphoneIcon />,
      permission: "softphone_user.get",
    },
    // {
    //   item: "voicemail_dashboard",
    //   path: "analytics",
    //   displayName: "Analytics",
    //   icon: <AnaltyticsIcon />,
    //   permission: "",
    //   childrens: [
    //     {
    //       item: "smtp",
    //       path: "smtp",
    //       displayName: "SMTP",
    //       permission: "voicemail_dashboard.get",
    //     },
    //   ],
    // },
    // {
    //   item: "extensions",
    //   path: "extensions",
    //   displayName: "Extensions",
    //   icon: <SoftphoneIcon />,
    //   permission: "extensions_tenant_admin.get",
    // },
  ],
};
